"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // TODO: Testing needed

var display = function display(props) {
  if (props === void 0) {
    props = {};
  }

  var styles = {};

  if (props.dp) {
    if (props.dp === 'table-fixed') {
      styles['table-layout'] = 'fixed';
      styles.display = 'table';
    } else {
      styles.display = props.dp;
    }
  }

  return styles;
};

exports.default = display;